<div class="container-login-btn {{disabledClass()}}" (click)="onClick($event)">
    <div tabindex="0">{{buttonTitle}}</div>
	<img *ngIf="buttonImage != null" class="centered" [style]="buttonImageStyle" [ngStyle]="{'transform':'rotate(180deg)'}" [src]="buttonImage" alt="Login Button" width="45px" tabindex="0">	
</div>